// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2PKJT","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2Vg5l"};